import React, { useEffect, useState } from "react";
// import { LoginData } from "../../interface/loginInterface";
import "./login.css";
import { css } from "@emotion/react";
import BeatLoader from "react-spinners/BeatLoader";
import { User } from "../../types/login";
import mainLogo from "../../icons/logo.svg";
import AdminLogin from "../../API/adminLogin";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUser } from "../../store/actions";

import { ERROR_TOAST, INFO_TOAST, SUCCESS_TOAST } from "../../helpers/toasters";
import { Link } from "react-router-dom";

//css for loader

const override = css`
  display: block;
  margin: 0 auto;
`;

//hot toast for showing error in login

const Login = (props: any) => {
  const [user, setUserData] = useState<User>({ email: "", password: "" });
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);

  const [isCancelled, setCancelled] = useState<boolean>(false);
  const [userInput, setUserInput] = useState<boolean>(false);


  const handelChange = (e: React.ChangeEvent<any>) => {
    const { name, value } = e.target;
    setUserData({ ...user, [name]: value });
    setUserInput(true);
  };
  const dispatch = useDispatch();

  const showData: any = async () => {
    setLoading(true);
    try {
      const response = await AdminLogin(user);
      
      
      if (response.message === "success") {
        dispatch(setUser(response.data));
        localStorage.setItem("refToken", response.data.accessToken);
        setLoading(false);
        SUCCESS_TOAST(`Welcome ${response.data.name} 🎉`);
        navigate("/");
        return
      }

      // if (response.message) {
      setLoading(false);
      return INFO_TOAST(response.data);
      // }

      setLoading(false);
      return INFO_TOAST("Something Went Wrong, Try Again!");
    } catch (e) {
      setLoading(false);
      return ERROR_TOAST("Error: Email or Password is incorrect!");
    }
  };

  // //memory leak warnings fixed here
  // useEffect(() => {
  //   if (userInput) {
  //     showData();
  //   }

  //   return () => {
  //     setCancelled(false);
  //     setUserInput(false)
  //   };
  // }, [])


  return (
    <>

      <div className="background-login">
        <div className="card-login">
          <div className="top-login">
            <h2 className="login-text">Login </h2>
            <img src={mainLogo} alt="suprkid logo" />
          </div>
          <div id="login-middle-border"></div>
          <div className="center-login">
            <label className="login-label" htmlFor="email">
              Email ID
            </label>
            <input
              type="email"
              name="email"
              className="login-inp"
              onChange={handelChange}
            />
            <label className="login-label" htmlFor="pass">
              Password
            </label>
            <input
              type="password"
              name="password"
              className="login-inp"
              onChange={handelChange}
            />
            <Link to="/forgot-password" className="login-forgot">Forgot Password?</Link>
          </div>
          <div className="bottom-login">
            <button
              className="login-btn"
              onClick={showData}
              disabled={user.email === "" && user.password === ""}
            >
              {loading ? <BeatLoader color={"#fff"} css={override} /> : "Login"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
export default Login;